import { DefaultButton, ImageBase, Label, MessageBar, MessageBarButton, MessageBarType, Panel, PanelType, PrimaryButton, Spinner, Stack, TextField, Toggle } from "@fluentui/react";
import React, { useEffect, useRef } from "react";
import { FunctionComponent, useState } from "react";
import { IUbicaciones, IUbicacionEditar } from "../../../../interfaces/ubicacion/IUbicacion";
import UbicacionService from "../../../../services/ubicacionesServices";
import { fileToBase64 } from "../../../../utils/Helper/detalleArchivoHelper";
import blobStorageService from "../../../../services/blobStorageService";
interface EditarUbicacionProps {
  isOpen: boolean;
  onDismiss: () => void;
  item: IUbicaciones;
  setActualizar: () => void;
}

const EditarUbicacion: FunctionComponent<EditarUbicacionProps> = (prop) => {
  const [formulariosEditados, setformulariosEditados] = useState<IUbicacionEditar>();
  const [tipoMensaje, setTipoMensaje] = useState(0);
  const [verLoading, setVerLoading] = useState(false);
  const imageInputRef = useRef<HTMLInputElement>(null);
  const [base64, setBase64] = useState<string | null>(null);
  const [loadingImage, setLoadingImage] = useState(false);

  useEffect(() => {

    if (prop.item !== undefined) {
      let objetoInterface: IUbicacionEditar = {
        ubicacionId: prop.item.ubicacionId,
        nombre: prop.item.nombre,
        codigo: prop.item.codigo,
        viajeAutorizado: prop.item.viajeAutorizado,
        lugarAutorizado: prop.item.lugarAutorizado,
        lugarDeEmbarque: prop.item.lugarEmbarque,
        imagenReferencial: prop.item.imagenReferencial
      }

      if (objetoInterface.imagenReferencial) {
        cargarImagen(objetoInterface.imagenReferencial)
      }

      setformulariosEditados(objetoInterface)
    }
  }, [prop.isOpen]);

  const cargarImagen = (imagen?: string) => {
    if (imagen !== undefined) {
      setLoadingImage(true)
      blobStorageService.obtenerBlob({
        url: imagen,
        codigo: "59"
      }).then((res) => {
        if (res.status == 200) {
          setBase64("data:image/*;base64," + res.data.archivo)
        }
      }).catch((e: Error) => {
        console.log(e.message)
      }).finally(() => {
        setLoadingImage(false)
      })
    }
  }

  const onChangeInputName = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    if (newValue !== undefined) {
      setformulariosEditados({
        ...formulariosEditados, nombre: newValue!
      }
      )
    }
  }

  const onChangeInputCodigo = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    if (newValue !== undefined) {
      console.log("pass")
      setformulariosEditados({
        ...formulariosEditados, codigo: newValue
      }
      )
    }
  }

  function _onChangeEmbarque(ev: React.MouseEvent<HTMLElement>, checked?: boolean) {
    console.log('toggle is ' + (checked ? 'checked' : 'not checked'));
    setformulariosEditados({ ...formulariosEditados, lugarDeEmbarque: checked })
  };

  function _onChangeVueloAutorizado(ev: React.MouseEvent<HTMLElement>, checked?: boolean) {
    console.log('toggle is ' + (checked ? 'checked' : 'not checked'));
    setformulariosEditados({ ...formulariosEditados, viajeAutorizado: checked })
  };

  function _onChangeLugarAutorizado(ev: React.MouseEvent<HTMLElement>, checked?: boolean) {
    console.log('toggle is ' + (checked ? 'checked' : 'not checked'));
    setformulariosEditados({ ...formulariosEditados, lugarAutorizado: checked })
  };


    const onChangeImagen = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files !== null) {
        const file = event.target.files[0];
        fileToBase64(file, (err: any, result: any) => {
          if (result) {
            setformulariosEditados({ ...formulariosEditados, imagenReferencial: result, imagenReferencialExtension: file.name.split(".").pop() })
            setBase64(result)
          }
          if (err) {
            console.error(err)
          }
        })
      }
    }
  
    const alSeleccionarImagen = () => {
      imageInputRef.current?.click();
    }

  const onClickRegistrar = () => {
    if (formulariosEditados !== undefined) {
      UbicacionService.ubicacionEditar(formulariosEditados).then(
        (res) => {
        
          if (res.status == 200) {
            console.log(res)
            setVerLoading(true);
            setTipoMensaje(2);
          }
        }
      )
        .catch(
          (e: Error) => {
            console.log(e.message)
            // setChoice('error')
            setVerLoading(false);
            setTipoMensaje(1);
          }
        )
    }
  }

  const _return =()=>{
    prop.setActualizar()
    prop.onDismiss()
    
  }
  const gapb = { childrenGap: 5 }
  const onRenderFooterContent = React.useCallback(
    () => (
      <div>
        <Stack horizontal horizontalAlign="end" tokens={gapb} >
          <PrimaryButton onClick={onClickRegistrar} styles={{ root: { marginLeft: "30px" } }} >
            Guardar
          </PrimaryButton>
          <DefaultButton onClick={prop.onDismiss} styles={{ root: { marginLeft: "0px" } }}>Cancelar</DefaultButton>
        </Stack>
      </div>
    ),
    [formulariosEditados],
  );



  return (
    <Panel
      headerText="Editar Ubicación"
      isOpen={prop.isOpen}
      onDismiss={prop.onDismiss}
      type={PanelType.medium}
      closeButtonAriaLabel="Close"
      onRenderFooterContent={onRenderFooterContent}
      isFooterAtBottom={true}
    >
      {tipoMensaje == 1 && (
        <>
          <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={false}
            onDismiss={() => {
              setTipoMensaje(0);
            }}
            dismissButtonAriaLabel="Close"
          >
            "Error"
          </MessageBar>
          <br></br>
        </>
      )}

      {tipoMensaje == 2 &&

        <>
          <MessageBar
            actions={
              <div>
                <MessageBarButton  onClick={_return}>
                  Conforme
                </MessageBarButton>
              </div>
            }
            messageBarType={MessageBarType.success}
            isMultiline={false}
          >
            Ubicacion editada exitosamente
          </MessageBar>
          <br></br>
        </>
      }
      {!verLoading && (
        <>
      <Stack >
        <TextField label="Nombre" value={formulariosEditados == undefined ? "" : formulariosEditados.nombre} onChange={onChangeInputName} />
        <TextField label="Código" value={formulariosEditados == undefined ? "" : formulariosEditados.codigo} onChange={onChangeInputCodigo} />
        <Toggle
          label="Lugar de Embarque"
          checked={formulariosEditados == undefined ? true : formulariosEditados.lugarDeEmbarque}
          onText="Sí"
          offText="No"
          onChange={_onChangeEmbarque} />
        <Toggle
          label="Lugar Autorizado"
          onText="Sí"
          offText="No"
          checked={formulariosEditados == undefined ? true : formulariosEditados.lugarAutorizado}
          onChange={_onChangeLugarAutorizado} />
        <Toggle
          label="Viaje Autorizado"
          onText="Sí"
          offText="No"
          onChange={_onChangeVueloAutorizado}
          checked={formulariosEditados == undefined ? true : formulariosEditados.viajeAutorizado}
        />

        <>
          <Label>Imagen referencial</Label>
          <input ref={imageInputRef} type="file" accept="image/*" multiple={false} onChange={onChangeImagen} style={{ display: 'none' }} />
          <DefaultButton onClick={alSeleccionarImagen} style={{ marginBottom: '10px' }} >Seleccionar Imagen</DefaultButton>
          {loadingImage && <Spinner label="Cargando imagen..." />}
          {base64 && <ImageBase src={base64} styles={{ root: { margin: 'auto' }, image: { maxHeight: '300px' }}} />}
        </>

      </Stack>
      </>)}
    </Panel>
  );
}



export default EditarUbicacion;